import { TooltipHost, Text, TooltipOverflowMode, IconButton, Callout, DelayedRender, mergeStyleSets, ITooltipHostStyles } from "@fluentui/react";
import { useBoolean, useId } from "@fluentui/react-hooks";
import React from "react";

const classNames = mergeStyleSets({
    inputWrapper:
    {
        paddingBottom: '20px',

    },
    callout: {
        padding: '8px',
    },
    copyIconClass: {
        fontSize: "16px !important",
        lineHeight: "16px !important",
    }
});

const tooltipHostStyles: Partial<ITooltipHostStyles> = {
    root: {
        display: 'inline-block',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
        
    }
};

export interface ReadonlyFieldProps {
    fieldInternalName: string
    content: string
    showCopyButton: boolean,
    className?: string
}

const ReadonlyField: React.FunctionComponent<ReadonlyFieldProps> = props => {
    let [isCopyClipboardCalloutVisible, { setTrue: showCopyClipboardCalloutVisible, setFalse: hideCopyClipboardCalloutVisible }] = useBoolean(false);

    const copyButtonId = useId(`copy-button-${props.fieldInternalName}`);

    const copyToClipboard = (value) => {
        navigator.clipboard.writeText(value);
        showCopyClipboardCalloutVisible();
        setTimeout(() => { hideCopyClipboardCalloutVisible(); }, 3000);

    }

    const renderCopyClipboardCallout = () => {
        if (isCopyClipboardCalloutVisible) {
            return (
                <Callout className={classNames.callout} target={`#${copyButtonId}`} onDismiss={hideCopyClipboardCalloutVisible} role="alert">
                    <DelayedRender>
                        <Text variant="small">
                            Valore copiato negli appunti
                        </Text>
                    </DelayedRender>
                </Callout>
            )
        }
    }
    if (props.content) {
        return (
            <div className={`flex flex-row align-items-center ${props.className}`}>
                <TooltipHost
                    content={props.content}
                    styles={tooltipHostStyles}
                    overflowMode={TooltipOverflowMode.Self}
                >
                    <Text>
                        {props.content}
                    </Text>
                </TooltipHost>

                {props.showCopyButton && props.content && props.content !== "-" &&
                    <IconButton id={copyButtonId} iconProps={{ iconName: 'Copy', className: classNames.copyIconClass }} onClick={() => copyToClipboard(props.content)} />
                }
                {props.showCopyButton && props.content && props.content !== "-" &&
                    renderCopyClipboardCallout()
                }


            </div>
        );
    }
    else return <React.Fragment></React.Fragment>
}
export default ReadonlyField;
